/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// BEGIN PLACEHOLDER REPLACE AS PART OF TP-3958 (MOVE)
// This should be moved to whereever rxjs internal extensions ends up

import { Observable } from 'rxjs';
import { IObservableLike } from '../interfaces/IObservable';

export function isObservable<T>(ob$: IObservableLike<T>): ob$ is Observable<T> {
	return ob$.subscribe !== undefined;
}

/**
 * Provides a cross rxjs version compatible layer that should allow for conversion from anything that implements the [[IObservableLike]]
 * interface and some "concrete" implementation of rxjs
 */
export function standardizeObservable<T>(source: IObservableLike<T>): Observable<T> {
	if (!isObservable(source)) {
		throw new Error('input is not observable-like');
	}
	return new Observable((subscriber) => {
		return source.subscribe(
			(value) => subscriber.next(value),
			(err) => subscriber.error(err),
			() => subscriber.complete()
		);
	});
}

// END PLACEHOLDER REPLACE AS PART OF TP-3958 (MOVE)
